export default __webpack_public_path__ + "static/pre-flight-page-preview-section-bg-235260179d89dc5c054ca23e7649c44b.jpg";